import React from "react";
import LineTitle from "../../../app/atoms/LineTitle";
import { useAuth } from "../../../../context/security/AuthProvider";
import {
  useEntry,
  useDispatchEntryForm,
  useActionsEntry,
} from "../../../../context/inventory/EntryFormProvider";
import { types } from "../../../../reducers/inventory/entryReducer";
import Select from "react-select";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import {
  faCheckCircle,
  faChevronDown,
  faChevronUp,
  faEraser,
  faPlusSquare,
  faSave,
  faSearch,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./entryForm.css";
import ModalItem from "./ModalItem";
import { customStyles } from "../../../../utilities/select-styles.utilities";
import Observations from "./Observations";
import Document from "./Document";
import InputSearch from "../../../app/atoms/InputSearch";
import Moment from "react-moment";
import {
  FORMAT_DATE_PICKER,
  FORMAT_DATE_TIME_MOMENT,
  FORMAT_TIME,
  STATUS_EXCUTED,
  STATUS_IN_PROGRESS,
  TYPE_ENTRIES,
} from "../../../../api/constant";
import { countArrayGroupBy } from "../../../../utilities/math.utilities";
import StatusEntry from "./StatusEntry";
import { getTypeMeasure } from "../../../../utilities/app.utilities";
const EntryForm = () => {
  const state = useAuth();
  const entry = useEntry();
  const entryActions = useActionsEntry();

  const dispatchEntryForm = useDispatchEntryForm();
  const { warehouses } = state.user;
  const {
    lookForCode,
    lookedItems,
    panelObservation,
    lookForProvider,
    lookedProviders,
  } = entry;
  const { up, watchDocuments } = panelObservation;

  const {
    id,
    quantity_references,
    date_movement,
    order_number,
    items,
    created_at,
    business_client_id,
    business_name,
    business_nit,
    status_id,
    warehouse_id,
    type,
  } = entry.entry;
  const { item_id } = entry.modalItem;

  const changeInputEntry = (e) => {
    dispatchEntryForm({
      type: types.CHANGE_INPUT_ENTRY,
      payload: { name: e.target.name, value: e.target.value },
    });
  };

  const isNumberInput = (e) => {
    if (/^([0-9])*$/.test(e.target.value))
      changeInputEntry(e)
  }

  return (
    <div>
      <div className="container-lg">
        {item_id && <ModalItem />}
        <section className="flex">
          <LineTitle title={"Entradas de producto"}>
            <StatusEntry status_id={status_id} />
          </LineTitle>
        </section>
        <br />
        <section className="row">
          <div className="form-group col-md-3 col-lg-3">
            <Select
              value={warehouses.filter((w) => w.id === warehouse_id)}
              placeholder="Almacén"
              getOptionLabel={(option) => option.code + " - " + option.name}
              getOptionValue={(option) => option.id}
              options={warehouses}
              styles={customStyles}
              isDisabled={status_id === STATUS_EXCUTED || status_id === STATUS_IN_PROGRESS}
              onChange={(e) =>
                dispatchEntryForm({
                  type: types.CHANGE_INPUT_ENTRY,
                  payload: { name: "warehouse_id", value: e ? e.id : null },
                })
              }
            />
          </div>

          <div className="form-group flex col-md-2 col-lg-2">
            <label className="font1 margin-auto">ID Entrada</label>
          </div>
          <div className="form-group col-md-3 col-lg-1">
            <div disabled className="form-control">
              {" "}
              &nbsp;
              {id}{" "}
            </div>
          </div>

          <div className="form-group col-md-3 col-lg-2">
            <div disabled className="form-control">
              {id && (
                <Moment format={FORMAT_DATE_TIME_MOMENT}>{created_at}</Moment>
              )}
              &nbsp;
            </div>
          </div>
        </section>
        <br />
        <section className="row">
          <div className="form-group col-lg-3">
            <label>Proveedor - Nit</label>
            <div className="input-to-search">
              <input
                name="lookForProvider"
                value={
                  business_client_id
                    ? business_name + " - " + business_nit
                    : lookForProvider
                }
                disabled={business_client_id}
                onChange={(e) =>
                  dispatchEntryForm({
                    type: types.CHANGE_INPUT_ENTRY_FORM,
                    payload: { name: e.target.name, value: e.target.value },
                  })
                }
                type="text"
                className="form-control"
              />
              <FontAwesomeIcon
                onClick={() =>
                  business_client_id &&
                  !status_id &&
                  dispatchEntryForm({ type: types.REMOVE_PROVIDER })
                }
                className="cursor-pointer"
                icon={business_client_id && !status_id ? faEraser : faSearch}
              />
            </div>

            {lookedProviders.length > 0 && !business_client_id && (
              <div className="container-items-looked-for flex-column">
                {lookedProviders.map((pro) => {
                  return (
                    <label
                      key={pro.id}
                      onClick={(e) =>
                        dispatchEntryForm({
                          type: types.CHANGE_PAYLOAD_ENTRY,
                          payload: {
                            ...entry.entry,
                            business_client_id: pro.id,
                            business_name: pro.name,
                            business_nit: pro.doc_num,
                          },
                        })
                      }
                    >
                      {pro.name} - {pro.doc_num}
                    </label>
                  );
                })}
              </div>
            )}
          </div>

          <div className="form-group  col-lg-2">
            <label htmlFor="inputType">Tipo doc. enviado</label>
            <Select
              value={TYPE_ENTRIES.filter((w) => w.code === type)}
              placeholder="Tipo de doc"
              getOptionLabel={(option) => option.name}
              getOptionValue={(option) => option.code}
              options={TYPE_ENTRIES}
              styles={customStyles}
              isDisabled={status_id === STATUS_EXCUTED || status_id === STATUS_IN_PROGRESS}
              onChange={(e) =>
                dispatchEntryForm({
                  type: types.CHANGE_INPUT_ENTRY,
                  payload: { name: "type", value: e ? e.code : null },
                })
              }
            />
          </div>
          <div className="form-group col-lg-2 ">
            <label>No de documento</label>
            <input
              value={order_number}
              disabled={status_id === STATUS_EXCUTED || status_id === STATUS_IN_PROGRESS}
              onChange={(e) => changeInputEntry(e)}
              type="text"
              className="form-control"
              name="order_number"
            />
          </div>
          <div className="form-group   col-lg-2">
            <label>Fecha de doc</label>
            <DatePicker
              className="form-control"
              selected={date_movement}
              disabled={status_id === STATUS_EXCUTED || status_id === STATUS_IN_PROGRESS}
              onChange={(e) =>
                dispatchEntryForm({
                  type: types.CHANGE_INPUT_ENTRY,
                  payload: { name: "date_movement", value: e },
                })
              }
              dateFormat={FORMAT_DATE_PICKER}
            />
          </div>
          <div className="form-group col-lg-1">
            <label>Cant. ref.</label>
            <input
              onChange={(e) => isNumberInput(e)}
              type="text"
              disabled={status_id === STATUS_EXCUTED || status_id === STATUS_IN_PROGRESS}
              value={quantity_references}
              className="form-control"
              name="quantity_references"
            />
          </div>
          <div className="form-group  col-lg-1">
            <label>Ref.</label>
            <div
              style={{
                backgroundColor:
                  countArrayGroupBy(items, "code") ===
                    parseFloat(quantity_references)
                    ? "var(--green)"
                    : "white",
              }}
              className="form-control"
            >
              {countArrayGroupBy(items, "code") + "/" + quantity_references}
            </div>
          </div>
          <div className=" form-group col-md-3 col-lg-1">
            <label></label>
            {!id && (
              <div
                onClick={() => entryActions.createEntry()}
                className="btn-default"
              >
                <FontAwesomeIcon icon={faPlusSquare} />
                &nbsp;
                <span>Crear</span>
              </div>
            )}
          </div>
        </section>
        <hr />
        {id && (
          <>
            <div className="form-group col-md-4 col-lg-4">
              {status_id !== STATUS_EXCUTED && (
                <div className="input-search-code">
                  <label>Digite código o nombre</label>
                  <InputSearch>
                    <input
                      type="text"
                      name="lookForCode"
                      value={lookForCode}
                      onChange={(e) =>
                        dispatchEntryForm({
                          type: types.CHANGE_INPUT_ENTRY_FORM,
                          payload: {
                            name: e.target.name,
                            value: e.target.value,
                          },
                        })
                      }
                      className="form-control"
                    />
                  </InputSearch>

                  {lookedItems.length > 0 && (
                    <div className="container-items-looked-for flex-column">
                      {lookedItems.map((item) => {
                        return (
                          <label
                            key={item.id}
                            onClick={(e) => {
                              dispatchEntryForm({
                                type: types.OPEN_MODAL_ITEM,
                                payload: {
                                  item_id: item.id,
                                  name: item.name,
                                  abreviature: item.abreviature,
                                  measure_name: item.measure_name,
                                  code: item.code,
                                  has_lote: item.has_lote,
                                  has_date_made: item.has_date_made,
                                  has_date_expired:item.has_date_expired
                                },
                              });
                              dispatchEntryForm({
                                type: types.CLEAN_ITEMS_FOUND,
                              });
                            }}
                          >
                            {item.code} - {item.name} - {item.abreviature}
                          </label>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}
            </div>
            <table className="table table-default-app">
              <thead>
                <tr>
                  <th scope="col">Item</th>
                  <th scope="col">Referencia</th>
                  <th scope="col">Nombre</th>
                  <th scope="col">Und. medida</th>
                  <th scope="col">Cant.</th>
                  <th scope="col">Lote</th>
                  <th scope="col">Fecha vencimiento</th>
                  <th scope="col">Fecha fabricación</th>

                  <th scope="col">Tipo de medida</th>
                  <th scope="col">Marca</th>
                  <th scope="col">Fecha ingreso</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, i) => {
                  if (item.date_expired === "2300-12-31") {
                    item.lote = "N.A"
                    item.date_expired = "N.A";
                  }
                  if (item.date_expired==null) {
                    item.date_expired = "N.A";
                  }
                  return (
                    <tr key={i}>
                      <td scope="row">{i + 1} </td>
                      <td>{item.code}</td>
                      <td> {item.name}</td>
                      <td>{item.measure}</td>
                      <td>{item.quantity}</td>
                      <td>{item.lote}</td>
                      <td>{item.date_expired}</td>
                      <td>{item.date_made}</td>

                      <td>{getTypeMeasure(item.type_measure)}</td>

                      <td>{item.brand_name}</td>
                      <td>
                        <Moment format={FORMAT_TIME}>
                          {status_id !== STATUS_EXCUTED
                            ? item.created_at
                            : created_at}
                        </Moment>
                      </td>
                      <th>
                        {status_id !== STATUS_EXCUTED && (
                          <FontAwesomeIcon
                            onClick={() => entryActions.deleteDetail(item.id)}
                            className="cursor-pointer blue"
                            icon={faTrashAlt}
                          />
                        )}
                      </th>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <br />
            {status_id !== STATUS_EXCUTED && items.length > 0 && (
              <div className="flex justify-end">
                <button
                  onClick={() => entryActions.finishEntry()}
                  className="btn-default "
                >
                  <FontAwesomeIcon icon={faCheckCircle} />
                  &nbsp;
                  <span>Finalizar</span>
                </button>
              </div>
            )}
          </>
        )}
      </div>
      {id && (
        <div
          className={` ${up ? "fade-in-observation" : "fade-out-observation"
            } container-footer-observation-entry`}
        >
          <div>
            <div className="flex container-tabs-entry">
              <div
                onClick={() =>
                  dispatchEntryForm({
                    type: types.SET_PANEL_OBSERVATION,
                    payload: false,
                  })
                }
                className={` ${watchDocuments && "tab-inactive-entry"} `}
              >
                Observaciones
              </div>
              <div
                onClick={() =>
                  dispatchEntryForm({
                    type: types.SET_PANEL_OBSERVATION,
                    payload: true,
                  })
                }
                className={` ${!watchDocuments && "tab-inactive-entry"} `}
              >
                Archivos
              </div>{" "}
            </div>

            <div
              onClick={() =>
                dispatchEntryForm({ type: types.TOGGLE_PANEL_OBSERVATION })
              }
              className="button-up-footer-obsevation-entry"
            >
              <FontAwesomeIcon
                className="margin-auto blue"
                icon={up ? faChevronDown : faChevronUp}
              />{" "}
            </div>
            <br />
            <div className="content-tab-observation-entry">
              {" "}
              {!watchDocuments && up && <Observations />}
              {watchDocuments && up && <Document />}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EntryForm;
